import React, { useEffect } from "react";

const UniversalModal = ({ isOpen, title, onClose, children, footer }) => {
  useEffect(() => {
    if (!isOpen) return undefined;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = originalOverflow;
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="uni-modal-root" role="dialog" aria-modal="true" aria-label={title || "Модальное окно"}>
      <button className="uni-modal-backdrop" type="button" onClick={onClose} aria-label="Закрыть" />

      <div className="uni-modal-card">
        <header className="uni-modal-head">
          <h3>{title}</h3>
          <button className="uni-modal-close" type="button" onClick={onClose} aria-label="Закрыть окно">
            <i className="fa-solid fa-xmark" aria-hidden="true"></i>
          </button>
        </header>

        <section className="uni-modal-body">{children}</section>

        {footer ? <footer className="uni-modal-foot">{footer}</footer> : null}
      </div>
    </div>
  );
};

export default UniversalModal;
